import { graphql } from '@/generated/gql';

export const INTAKE_UPDATE_QUOTE_ANALYSIS = graphql(/* GraphQL */ `
  subscription OnCompletedIntakeQuoteAnaylsis($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id
        status
        analysis {
          id
          fileId
          status
        }
      }
    }
  }
`);
